var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContactLocationIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0742 21.8187C12.7295 22.0604 12.2699 22.0601 11.9253 21.8184L11.9228 21.8166L11.9172 21.8127L11.8986 21.7994C11.8829 21.7882 11.8607 21.7722 11.8325 21.7517C11.7762 21.7106 11.6956 21.6511 11.5943 21.5741C11.3917 21.4203 11.1058 21.1962 10.7641 20.9101C10.0823 20.3389 9.17111 19.5139 8.25692 18.4988C6.46368 16.5076 4.5 13.6105 4.5 10.3636C4.5 8.16134 5.33118 6.0397 6.82548 4.46777C8.32141 2.89413 10.3615 2 12.5 2C14.6385 2 16.6786 2.89413 18.1745 4.46777C19.6688 6.0397 20.5 8.16134 20.5 10.3636C20.5 13.6105 18.5363 16.5076 16.7431 18.4988C15.8289 19.5139 14.9177 20.3389 14.2359 20.9101C13.8942 21.1962 13.6083 21.4203 13.4057 21.5741C13.3044 21.6511 13.2238 21.7106 13.1675 21.7517C13.1393 21.7722 13.1171 21.7882 13.1014 21.7994L13.0828 21.8127L13.0772 21.8166L13.0754 21.8179L13.0742 21.8187ZM9.5 10C9.5 8.34315 10.8431 7 12.5 7C14.1569 7 15.5 8.34315 15.5 10C15.5 11.6569 14.1569 13 12.5 13C10.8431 13 9.5 11.6569 9.5 10Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactLocationIc);
export default __webpack_public_path__ + "static/media/contactLocation_ic.f646c839.svg";
export { ForwardRef as ReactComponent };